import React from 'react';
interface ClothespinProps {
  className?: string;
  rotate?: number;
}
export function Clothespin({
  className = '',
  rotate = 0
}: ClothespinProps) {
  return <svg viewBox="0 0 30 60" width="22" height="44" className={className} style={{
    transform: `rotate(${rotate}deg)`,
    filter: 'drop-shadow(2px 3px 3px rgba(0,0,0,0.6))'
  }} data-id="element-56">
      <defs data-id="element-57">
        {/* Lighter, more realistic pine wood gradient */}
        <linearGradient id="woodGrad" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-58">
          <stop offset="0%" stopColor="#dcb589" data-id="element-59" />
          <stop offset="20%" stopColor="#e8c8a0" data-id="element-60" />
          <stop offset="50%" stopColor="#d4a878" data-id="element-61" />
          <stop offset="80%" stopColor="#c29462" data-id="element-62" />
          <stop offset="100%" stopColor="#b08050" data-id="element-63" />
        </linearGradient>

        {/* Darker wood for the back leg to create depth */}
        <linearGradient id="woodGradDark" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-64">
          <stop offset="0%" stopColor="#b08050" data-id="element-65" />
          <stop offset="50%" stopColor="#9a6b3e" data-id="element-66" />
          <stop offset="100%" stopColor="#85572c" data-id="element-67" />
        </linearGradient>

        {/* Shiny metal gradient for the spring */}
        <linearGradient id="metalGrad" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-68">
          <stop offset="0%" stopColor="#e0e0e0" data-id="element-69" />
          <stop offset="30%" stopColor="#ffffff" data-id="element-70" />
          <stop offset="50%" stopColor="#a0a0a0" data-id="element-71" />
          <stop offset="80%" stopColor="#d0d0d0" data-id="element-72" />
          <stop offset="100%" stopColor="#707070" data-id="element-73" />
        </linearGradient>

        {/* Realistic wood grain texture */}
        <pattern id="woodGrain" x="0" y="0" width="30" height="60" patternUnits="userSpaceOnUse" data-id="element-74">
          <path d="M 12 0 Q 14 15 12 30 T 13 60" stroke="rgba(139,69,19,0.15)" strokeWidth="0.5" fill="none" data-id="element-75" />
          <path d="M 15 0 Q 17 20 14 40 T 16 60" stroke="rgba(139,69,19,0.1)" strokeWidth="0.8" fill="none" data-id="element-76" />
          <path d="M 18 0 Q 16 10 19 25 T 17 60" stroke="rgba(139,69,19,0.15)" strokeWidth="0.5" fill="none" data-id="element-77" />
          <path d="M 14 5 Q 15 8 14 12" stroke="rgba(139,69,19,0.2)" strokeWidth="0.4" fill="none" data-id="element-78" />
          <path d="M 16 45 Q 17 48 16 52" stroke="rgba(139,69,19,0.2)" strokeWidth="0.4" fill="none" data-id="element-79" />
        </pattern>
      </defs>

      {/* Back wooden leg */}
      <path d="M 11 2 L 15 2 L 15 28 C 15 29 13 30 13 32 L 13 58 L 9 58 L 9 32 C 9 30 11 29 11 28 Z" fill="url(#woodGradDark)" data-id="element-80" />

      {/* Front wooden leg */}
      <path d="M 16 2 L 20 2 L 20 28 C 20 29 18 30 18 32 L 18 58 L 14 58 L 14 32 C 14 30 16 29 16 28 Z" fill="url(#woodGrad)" data-id="element-81" />

      {/* Wood grain overlay */}
      <path d="M 16 2 L 20 2 L 20 28 C 20 29 18 30 18 32 L 18 58 L 14 58 L 14 32 C 14 30 16 29 16 28 Z" fill="url(#woodGrain)" data-id="element-82" />

      {/* Indentations on the top grip */}
      <line x1="15" y1="6" x2="19" y2="6" stroke="rgba(139,69,19,0.3)" strokeWidth="0.5" data-id="element-83" />
      <line x1="15" y1="8" x2="19" y2="8" stroke="rgba(139,69,19,0.3)" strokeWidth="0.5" data-id="element-84" />
      <line x1="15" y1="10" x2="19" y2="10" stroke="rgba(139,69,19,0.3)" strokeWidth="0.5" data-id="element-85" />

      {/* Metal spring mechanism */}
      <g transform="translate(14.5, 30)" data-id="element-86">
        {/* The wire loop that goes over the front leg */}
        <path d="M -1.5 -2 L -5 5 L -5 12 L 5.5 12 L 5.5 5 L 2 -2" fill="none" stroke="url(#metalGrad)" strokeWidth="1.2" strokeLinejoin="round" data-id="element-87" />
        {/* Shadow under the wire loop */}
        <path d="M -1.5 -1 L -4.5 5 L -4.5 11 L 5 11 L 5 5 L 2 -1" fill="none" stroke="rgba(0,0,0,0.4)" strokeWidth="0.5" data-id="element-88" />

        {/* The central coiled spring */}
        <ellipse cx="0" cy="0" rx="3.5" ry="4.5" fill="none" stroke="url(#metalGrad)" strokeWidth="1.5" data-id="element-89" />
        <ellipse cx="0" cy="0" rx="3.5" ry="4.5" fill="none" stroke="rgba(0,0,0,0.3)" strokeWidth="0.5" data-id="element-90" />

        {/* Inner coil detail */}
        <path d="M -2 -2 Q 0 -4 2 -2" fill="none" stroke="url(#metalGrad)" strokeWidth="1" data-id="element-91" />
        <path d="M -2 2 Q 0 4 2 2" fill="none" stroke="url(#metalGrad)" strokeWidth="1" data-id="element-92" />
      </g>

      {/* Edge highlights for 3D effect */}
      <path d="M 14.5 32 L 14.5 58" stroke="rgba(255,255,255,0.4)" strokeWidth="0.5" data-id="element-93" />
      <path d="M 16.5 2 L 16.5 28" stroke="rgba(255,255,255,0.4)" strokeWidth="0.5" data-id="element-94" />
    </svg>;
}